import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mfp-back-button',
  templateUrl: './back-button.component.html',
  styleUrls: ['./back-button.component.scss']
})
export class BackButtonComponent {
  @Input() view = 'agent';
  @Input() label = '';

  @Output() arrowClicked = new EventEmitter();

  constructor() {}

  onClickArrow(): void {
    this.arrowClicked.emit();
  }
}
